const MUSIKK_PATH = 'assets/audio/spillmusikk.mp3';
const VOLUM_STANDARD = 0.25;
const STORAGE_KEY = 'forlagshuset:musikk-av';

export class AudioManager {
  private audio?: HTMLAudioElement;
  private mounted = false;
  private brukerStartet = false;

  start(): void {
    if (this.mounted) return;
    this.mounted = true;

    const audio = new Audio(MUSIKK_PATH);
    audio.loop = true;
    audio.volume = VOLUM_STANDARD;
    audio.preload = 'auto';
    audio.muted = this.lestErAv();
    this.audio = audio;

    const startVedInteraksjon = () => {
      if (this.brukerStartet) return;
      this.brukerStartet = true;
      audio.play().catch(() => {
        // browser-policy kan blokkere; bruker må trykke mute-knapp manuelt
      });
      window.removeEventListener('pointerdown', startVedInteraksjon);
      window.removeEventListener('keydown', startVedInteraksjon);
    };
    window.addEventListener('pointerdown', startVedInteraksjon, { once: true });
    window.addEventListener('keydown', startVedInteraksjon, { once: true });
  }

  get erAv(): boolean {
    return this.audio?.muted ?? this.lestErAv();
  }

  toggleMute(): boolean {
    // Fallback: hvis musikk ikke er mountet enda, bare toggle flagget i
    // localStorage slik at SFX også blir mutet/un-mutet.
    if (!this.audio) {
      const ny = !this.lestErAv();
      this.lagreErAv(ny);
      return ny;
    }
    const ny = !this.audio.muted;
    this.audio.muted = ny;
    this.lagreErAv(ny);
    if (!ny && this.audio.paused) {
      this.audio.play().catch(() => undefined);
    }
    return ny;
  }

  stopp(): void {
    if (!this.audio) return;
    try {
      this.audio.pause();
    } catch {
      // ignore
    }
    this.audio.removeAttribute('src');
    this.audio.load();
    this.audio = undefined;
    this.mounted = false;
  }

  private lestErAv(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  }

  private lagreErAv(av: boolean): void {
    try {
      localStorage.setItem(STORAGE_KEY, av ? '1' : '0');
    } catch {
      // ignore
    }
  }
}

export const audioManager = new AudioManager();
